/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

/*
*	NOTES: When customer adds an item to wishlist, separate records are created for 
*	each item and added to differnyt lists, such as "mylist","favourite" etc. where as
*	"mylist" is the predefined list provided by netsuite when a new customer register itself 
*	in webstore.
*/

// @module Facets
define(
	'Facets.ItemCell.View'
,	[
		'ProductLine.Stock.View'
	,	'Product.Model'
	,	'Profile.Model'
	,	'GlobalViews.StarRating.View'
	,	'Cart.QuickAddToCart.View'
	,	'ProductViews.Option.View'
	,	'ProductLine.StockDescription.View'
	,	'SC.Configuration'
	,	'Utils'
	,	'ProductList.ControlSingle.View'
	,	'Session'
	,	'ProductViews.Price.View'
	,	'ProductDetails.AddToProductList.View'

	,	'Backbone'
	,	'Backbone.CompositeView'
	,	'Backbone.CollectionView'
	,	'underscore'
	,	'jQuery'
	]
,	function (
		ProductLineStockView
	,	ProductModel
	,	ProfileModel
	,	GlobalViewsStarRating
	,	CartQuickAddToCartView
	,	ProductViewsOptionView
	,	ProductLineStockDescriptionView
	,	Configuration
	,	Utils
	,	ProductListControlSingleView
	,	Session
	,	ProductViewsPriceView
	,	ProductDetailsAddToProductListView

	,	Backbone
	,	BackboneCompositeView
	,	BackboneCollectionView
	,	_
	,	jQuery
	)
{
	'use strict';

	// @class Facets.ItemCell.View @extends Backbone.View
	return Backbone.View.extend({

		events:
		{
			'click [data-redirect="login"]' : 'redirectToLogin'
		,	'change [data-attr="unitstype"]' : 'changeRate'
		}

		//@method initialize Override default method to convert this View into Composite
		//@param {Facets.ItemCell.View.Initialize.Options} options
		//@return {Void}
	,	initialize: function (options)
		{
			BackboneCompositeView.add(this);
			
			this.Profile = ProfileModel.getInstance();	
			this.application = options.application;
			
			var product = new ProductModel({	
					item: this.model
				,	quantity: this.model.get('_minimumQuantity', true)
			})
			,	self = this
			,	favourites
			,	favouritesItems;

			this.login = Session.get('touchpoints.login');
			this.login += '&origin_hash=' + encodeURIComponent(Backbone.history.fragment);
			this.isLoading = true;

			this.application.ProductListModule.Utils.getProductListsPromise().done(function(listCollection){

				self.ProductListCollection = listCollection;
				favourites = _.find(self.ProductListCollection.models, function(model){
					return model.get('name') == "Favorites";
				});
				if( self.Profile.get('isLoggedIn') )
				{
					self.isProductAlreadyAdded = false;
					_.each(favourites.get('items').models, function(item){

						if( self.model.get('_id') == item.get('item').id )
						{
							self.listModelId = item.get('internalid');
							self.isProductAlreadyAdded = true;
						}
					});
					self.isLoading = false;
				}
				favourites.on('change',self._render(),this);
			});
			var profile = ProfileModel.getInstance();
			var custFlds = profile.get('customfields') || profile.attributes.customfields;
			this.isIvaluaLogin = false;
			if(custFlds && custFlds != null && custFlds != '' && custFlds != undefined)
			{
				var ivaluaLogin = '';
				for(var c=0; custFlds.length > 0 && c < custFlds.length; c++)
				{
					var fld = custFlds[c];
					if(fld.name == 'custentity_appf_ivalua_punchout')
						ivaluaLogin = fld.value;
				}
				if(ivaluaLogin !== '')
				{
					this.isIvaluaLogin = true;
				}
			}

		/*	 console.log(options.ProductListCollection);
			  if(options.ProductListCollection.length !== 0 )
			  {
			  	this.ProductListCollection = this.application.ProductListModule.Utils.getProductLists();

			  	favourites = _.find(this.ProductListCollection.models, function(model){
			  		return model.get('name') == "Favorites";
			  	});
			  	favouritesItems = favourites.get('items').models;	
				
			  	if( this.Profile.get('isLoggedIn') )
			  	{
			  		this.isProductAlreadyAdded = false; this.ProductListCollection.at(0).checked(product);
					
			  		var self = this;
			  		this.modelId = favouritesItems.forEach(function(model){
						
			  			if( self.model.get('_id') == model.get('item').id )
			  			{
			  				self.listModelId = model.get('internalid');
			  				self.isProductAlreadyAdded = true;
			  			}
			  		});
			  	}
			  	else	
			  	{
			  		window.location.href = this.login;
			  	}
			  	favourites.on('change',this._render(),this);
			  }*/

						
		}
	,	contextData: {
			'item': function ()
			{
				return Utils.deepCopy(this.model);
			}
		}

	,	childViews: {
			'ItemViews.Stock': function ()
			{
				return new ProductLineStockView({
					model: this.model
				});
			}

		,	'GlobalViews.StarRating': function()
			{

				var view = new GlobalViewsStarRating({
					model: this.model
				,	showRatingCount: false
				,	queryOptions: Utils.parseUrlOptions(location.href)
				});

				return this.options.showStarRating === false ? null : view;
			}

		,	'ItemDetails.Options': function()
			{
				var options_configuration = Configuration.get('ItemOptions.optionsConfiguration', []);

				return new BackboneCollectionView({
					collection: _.filter(this.model.get('options').sortBy('index'), function (option)
					{
						var option_configuration = _.findWhere(options_configuration, {cartOptionId: option.get('cartOptionId')});
						return option_configuration && option_configuration.showSelectorInList;
					})
				,	childView: ProductViewsOptionView
				,	viewsPerRow: 1
				,	childViewOptions: {
						item: this.model
					,	templateName: 'facetCell'
					,	showLink: true
					,	hideLabel: true
					,	showSmall: true
					}
				});
			}

		,	'Cart.QuickAddToCart': function ()
			{
				var product = new ProductModel({
					item: this.model
				,	quantity: this.model.get('_minimumQuantity', true)
				});

				return new CartQuickAddToCartView({
					model: product
				,	application: this.options.application
				});
			}

		,	'StockDescription': function ()
			{
				return new ProductLineStockDescriptionView({
					model: this.model
				});
			}
		
		,	'Price.View': function ()
			{
				return new ProductViewsPriceView({
					model: this.model
				,	origin: "ITEMCELL"
				});
			}
			
		,	'AddToProductList': function ()
			{
				var product = new ProductModel({
					item: this.model
				,	quantity: this.model.get('_minimumQuantity', true)
				});

				return new ProductDetailsAddToProductListView({
					model: product
				,	application: this.options.application || this.parentView.options.application
				,   isListView:true
				});
			}	
		}

	,	redirectToLogin:function()
		{
			window.location.href = this.login;
		}
	,	setInitUnitstype: function()
		{
			var self = this;
			_.each( this.model.get('options').models, function(model){
				var optModel = _.find(self.model.get('unitsType'),function(unit){
				return unit.isSelected == true;
			})
			
			,	saleUnit = _.find(self.model.get('unitsType'),function(unit){
					return unit.saleUnit == true;
				});
					
			var unitId = optModel ? optModel.id : (saleUnit ? saleUnit.id :(!_.isUndefined(self.model.get('unitsType'))?(self.model.get('unitsType').length>0 ? self.model.get('unitsType')[0].id : '' ) : ''));
			var unitName = optModel ? optModel.name : (saleUnit ? saleUnit.name :(!_.isUndefined(self.model.get('unitsType'))?(self.model.get('unitsType').length>0 ? self.model.get('unitsType')[0].name : '' ) : ''));



			if(model.get('cartOptionId') == 'custcol_appf_custom_uom_website')
			{
				model.set('value', {
					label:	unitId
				,	internalid: unitId
				});
				self.model.set('custcol_appf_custom_uom_website', unitId );
			}
			if(model.get('cartOptionId') == 'custcol_appf_custom_uom_label_website')
			{
				model.set('value', {
					label:	unitName
				,	internalid: unitName
				});
				self.model.set('custcol_appf_custom_uom_label_website', unitName );
			}
			if(model.get('cartOptionId') == 'custcol_appf_custom_uom_price_website')
			{
				var customprice = self.model.get('customprice')
				,	onlineprice = self.model.getPrice().price;
				customprice = customprice ? customprice.toString() : customprice;
				onlineprice = onlineprice ? onlineprice.toString() : onlineprice;

				model.set('value', {
				label:	customprice ? customprice : onlineprice
				,	internalid: customprice ? customprice : onlineprice
				});
				self.model.set('custcol_appf_custom_uom_price_website', (customprice || onlineprice) );
			}

			});
		}
		//@method Changes the Price.View based on the selected unitstype
	,	changeRate: function(e)
		{
			if(this.isIvaluaLogin)
			{
				
				var cartOptionId = jQuery(e.target).data('cart-option-id')
				,	value = jQuery(e.target).find('option:selected').val()
				,	text = jQuery(e.target).find('option:selected').text().trim()
			//	,	text = uomText.substr(0,uomText.lastIndexOf(' '))
				,	saleUnitObj = _.findWhere(this.model.get('unitsType'), {saleUnit: true})
				,	self = this
				,	customprice;
				
				_.each(this.model.get('unitsType'), function(unit){
					
					if(unit.id == value)
					{
						//var customprice = parseInt(unit.convertionRate) * self.model.getPrice().price;
						customprice = (self.model.getPrice().price / saleUnitObj.convertionRate) * unit.convertionRate;
						self.model.set('customprice',customprice);
					}
				});
				_.each( this.model.get('options').models, function(model){

					if(model.get('cartOptionId') == 'custcol_appf_custom_uom_website')//cartOptionId)
					{
						model.set('value',{
							label:value
						,	internalid: value
						});
						self.model.set('custcol_appf_custom_uom_website',value);
					}
					if(model.get('cartOptionId') == 'custcol_appf_custom_uom_label_website')
					{
						model.set('value',{
							label: text
						,	internalid: text
						});
						self.model.set('custcol_appf_custom_uom_label_website',text);
					}
					if(model.get('cartOptionId') == 'custcol_appf_custom_uom_price_website')
					{
						model.set('value',{
						label: customprice.toString()
						,	internalid: customprice.toString()
						});
						self.model.set('custcol_appf_custom_uom_price_website',customprice.toString());
					}
				});
			}
			else
			{
				var value = jQuery(e.target).val()
				,	unittype = _.find(this.model.get('unitsType'), function(unit){ return unit.id == value;})
				,	cRate = unittype ? unittype.convertionRate : ""
				,	saleUnitObj = _.findWhere(this.model.get('unitsType'), {saleUnit: true});
				if(cRate)
				{
					//var newPrice = parseInt(cRate) * this.model.getPrice().price;
					var newPrice = (this.model.getPrice().price / saleUnitObj.convertionRate) * cRate;
					this.model.set('customprice',newPrice);
				}
			}
		}

		//@method changeRateString toggles between different rate strings based on selected unitstype
	,	changeRateString: function(e)
		{
			var value = jQuery(e.target).val()
			,	element = jQuery(e.target).parent().siblings().find('.ratestring');
			jQuery(element).toggleClass('hide');
		}	
		
		//@method computeRateString	computes prices using convertion rate of each units type(To enable it add it to events{})
		//Returns<Array of Object>
	,	computeRateString: function()
		{
			var existingUnitType = this.model.get('unitsType') ||  [];
			var rateStringArr = [];
			for (var e = 0; e < existingUnitType.length; e++)
			{
				var conv = existingUnitType[e].convertionRate;
				var rate = this.model.get('onlinecustomerprice');
				var newRate = parseFloat(conv) * parseFloat(rate);
				newRate=Utils.formatCurrency(newRate);
				var obj = {};
				obj.id = existingUnitType[e].id;
				obj.baseUnit = existingUnitType[e].baseUnit;
				obj.rateString = existingUnitType[e].pcs+'/'+existingUnitType[e].abbrevation+' at '+newRate;
				rateStringArr.push(obj)
			}
			return rateStringArr || [];
		}	

		// @method getContext @returns {Facets.ItemCell.View.Context}
	,	getContext: function ()
		{
			if(this.isIvaluaLogin){
				this.setInitUnitstype();
			}

			var sds_pdfUrl = this.model.get('custitem_appf_sds_pdf_file_name');
			//var rateStringArr = this.computeRateString();	//comment it off to show computed price for every units type instead of actual Price.View
			//@class Facets.ItemCell.View.Context
			return {
				// @property {String} itemId
				itemId: this.model.get('_id')
				// @property {String} name
			,	name: this.model.get('_name')
				// @property {String} url
			,	url: this.model.get('_url')
				//@property {String} sku
			,	sku: this.model.getSku()
				//@property {String} price
			,	price: this.model.get('onlinecustomerprice')
				//@property {String} price_formatted
			,	price_formatted: this.model.get('onlinecustomerprice_formatted')

			//,   price_ns_str: rateStringArr	//	comment it off to enable computed price string
				//@property {String} description
			,	description: this.model.get('storedescription')
			
			,	hasSDSheet: (sds_pdfUrl != null && sds_pdfUrl != '')? true:false
			
			,	SDSSheet: sds_pdfUrl
				//@property {String} unitType
			,	unitsType: this.model.get('unitsType') ||  []
				// @property {Boolean} isEnvironmentBrowser
			,	isEnvironmentBrowser: SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled
				// @property {ImageContainer} thumbnail
			,	thumbnail: this.model.getThumbnail()
				// @property {Boolean} itemIsNavigable
			,	itemIsNavigable: !_.isUndefined(this.options.itemIsNavigable) ? !!this.options.itemIsNavigable : true
				//@property {Boolean} showRating
			,	showRating: SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled
				// @property {Number} rating
			,	rating: this.model.get('_rating')
				//@property {String} track_productlist_list
			,	track_productlist_list: this.model.get('track_productlist_list')
				//@property {String} track_productlist_position
			,	track_productlist_position: this.model.get('track_productlist_position')
				//@property {String} track_productlist_category
			,	track_productlist_category: this.model.get('track_productlist_category')
				//@property {Boolean} isLoggedIn(CUSTOM)
			,	isLoggedIn:	this.Profile.get('isLoggedIn') == "T" ? true : false
				//@property {Boolean} isProductAlreadyAdded(CUSTOM)
			,	isProductAlreadyAdded:	this.isProductAlreadyAdded
				//@property {String} listModelId(CUSTOM)
			,	listModelId: this.listModelId
				//@property {String} loginUrl(CUSTOM)
			,	loginUrl: this.login

			,	isLoading: this.isLoading
			
			,	itemid: this.model.get('itemid')
			
			,	uomExists:(this.model.get('unitsType') && this.model.get('unitsType').length > 0)?true:false
			,	isOutOfStock: this.model.get('_showOutOfStockMessage')
			,	outOfStockMsg: this.model.get('outofstockmessage')
			,	isIvaluaLogin: this.isIvaluaLogin
			};
			//@class Facets.ItemCell.View
		}
	});
});


//@class Facets.ItemCell.View.Initialize.Options
//@property {Item.Model} model
//@property {ApplicationSkeleton} application
//@property {Boolean?} itemIsNavigable
;
